import React from 'react';
import { type AhaNewRecordEditorProps } from './AhaNewRecordEditor';
import SuspenseWrapper from 'javascripts/SuspenseWrapper';

const LazyAhaNewRecordEditor = React.lazy(
  () => import(/* webpackChunkName: "aha-editor-v2" */ './AhaNewRecordEditor')
);

interface LazyProps extends AhaNewRecordEditorProps {
  fallback?: React.ReactNode;
}
/**
 * @param {any} param0
 */
export const AhaNewRecordEditor = ({
  fallback,

  ...props
}: LazyProps) => {
  return (
    <SuspenseWrapper fallback={fallback}>
      <LazyAhaNewRecordEditor {...props} />
    </SuspenseWrapper>
  );
};
